// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/chunks/18-d9a32186b242ddc9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"238":"565258303d23f1c5","255":"acc740b44a3d1d68","394":"287574b01d69bb5b","2268":"56336fcd81ae8289","2276":"451d510177d9907f","2848":"bb4d4b1faef26984","3478":"13b8fb10367bf7df","3655":"556d828b10638e80","3675":"c88edcfb0a06213a","9561":"8258dd1beadd8a75"}[chunkId] + ".js";
};